<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCoreStore } from '@/modules/core/store'
import { Skolear } from '@/modules/core/models/types'
import { ref, watch } from 'vue'
import SkolearValg from '@/modules/core/components/SkolearValg.vue'
import { useUngdommerStore } from '@/modules/ungdommer/store/UngdommerStore'
import router from '@/router'

const { setSkolearFraHurtigvalg } = useUngdommerStore()
const { aktivtSkolear } = storeToRefs(useCoreStore())
const valgtSkolear = ref(aktivtSkolear.value)

watch(valgtSkolear, (nyttSkolear, oldValue) => {
  if (!oldValue || nyttSkolear.kode !== oldValue.kode) {
    setValgtSkolear(nyttSkolear)
  }
})

function setValgtSkolear(skolearParam: Skolear) {
  valgtSkolear.value = skolearParam
  setSkolearFraHurtigvalg(skolearParam)

  if (
    !(
      'Ungdommer' === router.currentRoute.value?.name ||
      'Skrivebord' === router.currentRoute.value?.name ||
      'UngdomGrupper' === router.currentRoute.value?.name
    )
  ) {
    router.replace('/')
  }
}
</script>

<template>
  <div>
    <skolear-valg v-model="valgtSkolear" :show-label="false" />
  </div>
</template>

<style scoped lang="scss"></style>
